"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeAnimation = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var makeAnimation = exports.makeAnimation = function makeAnimation(_ref) {
  var _ref2;

  var name = _ref.name,
      from = _ref.from,
      to = _ref.to,
      on = _ref.on,
      duration = _ref.duration;
  return _ref2 = {}, (0, _defineProperty3.default)(_ref2, "& ." + name + "-enter", (0, _extends3.default)({}, from)), (0, _defineProperty3.default)(_ref2, "& ." + name + "-enter." + name + "-enter-active", (0, _extends3.default)({}, to, {
    transition: on + " " + duration + "ms ease-in-out"
  })), (0, _defineProperty3.default)(_ref2, "& ." + name + "-exit", (0, _extends3.default)({}, to)), (0, _defineProperty3.default)(_ref2, "& ." + name + "-exit." + name + "-exit-active", (0, _extends3.default)({}, from, {
    transition: on + " " + duration + "ms ease-in-out"
  })), _ref2;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/styles/styleHelpers.js
// module id = 131
// module chunks = 0